// AUTO-GENERATED by scripts/genEffectTypes.mjs from
// DDOBuilderV2/DDOBuilder/Effect.h — do not hand-edit.
// Regenerate after pulling upstream changes.

export type EffectTypeName =
  | 'ACBonus'
  | 'ACBonusShield'
  | 'AbilityBonus'
  | 'AddGroupWeapon'
  | 'ArcaneSpellFailure'
  | 'ArcaneSpellFailureShields'
  | 'ArmorACBonus'
  | 'ArmorCheckPenalty'
  | 'ArmorCheckPenaltyShield'
  | 'BlockingDR'
  | 'CasterLevel'
  | 'CasterLevelSchool'
  | 'CasterLevelSpell'
  | 'CreateSlider'
  | 'DR'
  | 'DRBypass'
  | 'DamageAbilityMultiplier'
  | 'DamageAbilityMultiplierOffhand'
  | 'DestinyAPBonus'
  | 'DestinyTree'
  | 'Displacement'
  | 'DivineGrace'
  | 'DodgeBonus'
  | 'DodgeBonusTowerShield'
  | 'DodgeBypass'
  | 'DodgeCapBonus'
  | 'Doubleshot'
  | 'Doublestrike'
  | 'DoublestrikeOffhand'
  | 'DragonmarkUse'
  | 'EldritchBlastD6'
  | 'EldritchBlastD8'
  | 'EnchantArmor'
  | 'EnergyAbsorbance'
  | 'EnergyResistance'
  | 'EnhancementTree'
  | 'ExcludeFeatSelection'
  | 'ExclusionGroup'
  | 'ExtraActionBoost'
  | 'ExtraLayOnHands'
  | 'ExtraRage'
  | 'ExtraRemoveDisease'
  | 'ExtraSmite'
  | 'ExtraTurns'
  | 'ExtraWildEmpathy'
  | 'FalseLife'
  | 'FatePoint'
  | 'Fortification'
  | 'FortificationBypass'
  | 'GhostTouch'
  | 'GrantFeat'
  | 'GrantSpell'
  | 'Guard'
  | 'HealingAmplification'
  | 'HelplessDamage'
  | 'HelplessDamageReduction'
  | 'HirelingAbilityBonus'
  | 'HirelingConcealment'
  | 'HirelingDodge'
  | 'HirelingFortification'
  | 'HirelingGrantFeat'
  | 'HirelingHitpoints'
  | 'HirelingMRR'
  | 'HirelingMeleePower'
  | 'HirelingPRR'
  | 'HirelingRangedPower'
  | 'HirelingSaveBonus'
  | 'HirelingSpellPower'
  | 'Hitpoints'
  | 'HitpointsReaper'
  | 'HitpointsStyleBonus'
  | 'ImbueDice'
  | 'Immunity'
  | 'ImplementBonus'
  | 'ImplementInYourHands'
  | 'Incorporeality'
  | 'ItemClickie'
  | 'KiCritical'
  | 'KiHit'
  | 'KiMaximum'
  | 'KiPassive'
  | 'LOHRegenRate'
  | 'MRR'
  | 'MRRCap'
  | 'MaxCasterLevel'
  | 'MaxCasterLevelSchool'
  | 'MaxCasterLevelSpell'
  | 'MaxDexBonus'
  | 'MaxDexBonusTowerShield'
  | 'MeleePower'
  | 'MergeGroups'
  | 'MetamagicCostAccelerate'
  | 'MetamagicCostEmbolden'
  | 'MetamagicCostEmpower'
  | 'MetamagicCostEmpowerHealing'
  | 'MetamagicCostEnlarge'
  | 'MetamagicCostEschewMaterials'
  | 'MetamagicCostExtend'
  | 'MetamagicCostHeighten'
  | 'MetamagicCostIntensify'
  | 'MetamagicCostMaximize'
  | 'MetamagicCostQuicken'
  | 'MissileDeflection'
  | 'MissileDeflectionBypass'
  | 'MovementSpeed'
  | 'NaturalArmor'
  | 'NegativeHealingAmplification'
  | 'NegativeLevel'
  | 'NotModeled'
  | 'OffHandAttackBonus'
  | 'OverrideBAB'
  | 'PRR'
  | 'PointBlankShotRange'
  | 'RAPBonus'
  | 'RangedPower'
  | 'RangedSneakAttackDamage'
  | 'RangedSneakAttackRange'
  | 'Regeneration'
  | 'RepairAmplification'
  | 'RuneArmChargeRate'
  | 'RuneArmStableCharge'
  | 'RustSusceptability'
  | 'SLACharge'
  | 'SaveBonus'
  | 'SaveBonusAbility'
  | 'SaveNoFailOn1'
  | 'SecondaryShieldBash'
  | 'ShieldEnchantment'
  | 'SkillBonus'
  | 'SkillBonusAbility'
  | 'SneakAttackAttack'
  | 'SneakAttackDamage'
  | 'SneakAttackDice'
  | 'SneakAttackRange'
  | 'SongACBonus'
  | 'SongAttackBonus'
  | 'SongCasterLevel'
  | 'SongCount'
  | 'SongDamageBonus'
  | 'SongDodgeBonus'
  | 'SongDoubleshot'
  | 'SongDoublestrike'
  | 'SongDuration'
  | 'SongHealingAmp'
  | 'SongMRR'
  | 'SongNegativeHealingAmp'
  | 'SongPRR'
  | 'SongRepairAmp'
  | 'SongSaveBonus'
  | 'SongSkillBonus'
  | 'SongSpellPenetration'
  | 'SongUniversalSpellPower'
  | 'SpellCostReduction'
  | 'SpellCriticalDamage'
  | 'SpellCooldownReduction'
  | 'SpellDC'
  | 'SpellLikeAbility'
  | 'SpellListAddition'
  | 'SpellLore'
  | 'SpellPenetrationBonus'
  | 'SpellPointCostPercent'
  | 'SpellPoints'
  | 'SpellPower'
  | 'SpellPowerReplacement'
  | 'SpellResistance'
  | 'Strikethrough'
  | 'TacticalDC'
  | 'ThreatBonusMelee'
  | 'ThreatBonusRanged'
  | 'ThreatBonusSpell'
  | 'TrueSeeing'
  | 'TumbleCharge'
  | 'TurnBonus'
  | 'TurnDiceBonus'
  | 'TurnLevelBonus'
  | 'TurnMaxDice'
  | 'UAPBonus'
  | 'UnconsciousRange'
  | 'UniversalSpellCriticalDamage'
  | 'UniversalSpellLore'
  | 'UniversalSpellPower'
  | 'Unknown'
  | 'WeaponAlacrityClass'
  | 'WeaponAttackAbilityClass'
  | 'WeaponAttackBonusClass'
  | 'WeaponAttackBonusCriticalClass'
  | 'WeaponAttackBonusCriticalDamageType'
  | 'WeaponAttackBonusDamageType'
  | 'WeaponCriticalMultiplierClass'
  | 'WeaponCriticalRangeClass'
  | 'WeaponDamageAbilityClass'
  | 'WeaponDamageBonusClass'
  | 'WeaponDamageBonusCriticalClass'
  | 'WeaponDamageBonusCriticalDamageType'
  | 'WeaponDamageBonusCriticalStat'
  | 'WeaponDamageBonusDamageType'
  | 'WeaponDamageBonusStat'
  | 'WeaponKeenDamageType'
  | 'WeaponOtherDamageBonus'
  | 'WeaponOtherDamageBonusClass'
  | 'WeaponOtherDamageBonusCritical'
  | 'WeaponOtherDamageBonusCriticalClass'
  | 'WeaponProficiencyClass'
  | 'Weapon_Alacrity'
  | 'Weapon_Attack'
  | 'Weapon_AttackAbility'
  | 'Weapon_AttackAndDamage'
  | 'Weapon_AttackAndDamageCritical'
  | 'Weapon_AttackCritical'
  | 'Weapon_BaseDamage'
  | 'Weapon_CriticalMultiplier'
  | 'Weapon_CriticalMultiplier19To20'
  | 'Weapon_CriticalRange'
  | 'Weapon_Damage'
  | 'Weapon_DamageAbility'
  | 'Weapon_DamageCritical'
  | 'Weapon_Enchantment'
  | 'Weapon_EnchantmentClass'
  | 'Weapon_Keen'
  | 'Weapon_VorpalRange'
  | 'WildsurgeChance';

export const EFFECT_TYPE_NAMES: readonly EffectTypeName[] = [
  'ACBonus',
  'ACBonusShield',
  'AbilityBonus',
  'AddGroupWeapon',
  'ArcaneSpellFailure',
  'ArcaneSpellFailureShields',
  'ArmorACBonus',
  'ArmorCheckPenalty',
  'ArmorCheckPenaltyShield',
  'BlockingDR',
  'CasterLevel',
  'CasterLevelSchool',
  'CasterLevelSpell',
  'CreateSlider',
  'DR',
  'DRBypass',
  'DamageAbilityMultiplier',
  'DamageAbilityMultiplierOffhand',
  'DestinyAPBonus',
  'DestinyTree',
  'Displacement',
  'DivineGrace',
  'DodgeBonus',
  'DodgeBonusTowerShield',
  'DodgeBypass',
  'DodgeCapBonus',
  'Doubleshot',
  'Doublestrike',
  'DoublestrikeOffhand',
  'DragonmarkUse',
  'EldritchBlastD6',
  'EldritchBlastD8',
  'EnchantArmor',
  'EnergyAbsorbance',
  'EnergyResistance',
  'EnhancementTree',
  'ExcludeFeatSelection',
  'ExclusionGroup',
  'ExtraActionBoost',
  'ExtraLayOnHands',
  'ExtraRage',
  'ExtraRemoveDisease',
  'ExtraSmite',
  'ExtraTurns',
  'ExtraWildEmpathy',
  'FalseLife',
  'FatePoint',
  'Fortification',
  'FortificationBypass',
  'GhostTouch',
  'GrantFeat',
  'GrantSpell',
  'Guard',
  'HealingAmplification',
  'HelplessDamage',
  'HelplessDamageReduction',
  'HirelingAbilityBonus',
  'HirelingConcealment',
  'HirelingDodge',
  'HirelingFortification',
  'HirelingGrantFeat',
  'HirelingHitpoints',
  'HirelingMRR',
  'HirelingMeleePower',
  'HirelingPRR',
  'HirelingRangedPower',
  'HirelingSaveBonus',
  'HirelingSpellPower',
  'Hitpoints',
  'HitpointsReaper',
  'HitpointsStyleBonus',
  'ImbueDice',
  'Immunity',
  'ImplementBonus',
  'ImplementInYourHands',
  'Incorporeality',
  'ItemClickie',
  'KiCritical',
  'KiHit',
  'KiMaximum',
  'KiPassive',
  'LOHRegenRate',
  'MRR',
  'MRRCap',
  'MaxCasterLevel',
  'MaxCasterLevelSchool',
  'MaxCasterLevelSpell',
  'MaxDexBonus',
  'MaxDexBonusTowerShield',
  'MeleePower',
  'MergeGroups',
  'MetamagicCostAccelerate',
  'MetamagicCostEmbolden',
  'MetamagicCostEmpower',
  'MetamagicCostEmpowerHealing',
  'MetamagicCostEnlarge',
  'MetamagicCostEschewMaterials',
  'MetamagicCostExtend',
  'MetamagicCostHeighten',
  'MetamagicCostIntensify',
  'MetamagicCostMaximize',
  'MetamagicCostQuicken',
  'MissileDeflection',
  'MissileDeflectionBypass',
  'MovementSpeed',
  'NaturalArmor',
  'NegativeHealingAmplification',
  'NegativeLevel',
  'NotModeled',
  'OffHandAttackBonus',
  'OverrideBAB',
  'PRR',
  'PointBlankShotRange',
  'RAPBonus',
  'RangedPower',
  'RangedSneakAttackDamage',
  'RangedSneakAttackRange',
  'Regeneration',
  'RepairAmplification',
  'RuneArmChargeRate',
  'RuneArmStableCharge',
  'RustSusceptability',
  'SLACharge',
  'SaveBonus',
  'SaveBonusAbility',
  'SaveNoFailOn1',
  'SecondaryShieldBash',
  'ShieldEnchantment',
  'SkillBonus',
  'SkillBonusAbility',
  'SneakAttackAttack',
  'SneakAttackDamage',
  'SneakAttackDice',
  'SneakAttackRange',
  'SongACBonus',
  'SongAttackBonus',
  'SongCasterLevel',
  'SongCount',
  'SongDamageBonus',
  'SongDodgeBonus',
  'SongDoubleshot',
  'SongDoublestrike',
  'SongDuration',
  'SongHealingAmp',
  'SongMRR',
  'SongNegativeHealingAmp',
  'SongPRR',
  'SongRepairAmp',
  'SongSaveBonus',
  'SongSkillBonus',
  'SongSpellPenetration',
  'SongUniversalSpellPower',
  'SpellCostReduction',
  'SpellCriticalDamage',
  'SpellCooldownReduction',
  'SpellDC',
  'SpellLikeAbility',
  'SpellListAddition',
  'SpellLore',
  'SpellPenetrationBonus',
  'SpellPointCostPercent',
  'SpellPoints',
  'SpellPower',
  'SpellPowerReplacement',
  'SpellResistance',
  'Strikethrough',
  'TacticalDC',
  'ThreatBonusMelee',
  'ThreatBonusRanged',
  'ThreatBonusSpell',
  'TrueSeeing',
  'TumbleCharge',
  'TurnBonus',
  'TurnDiceBonus',
  'TurnLevelBonus',
  'TurnMaxDice',
  'UAPBonus',
  'UnconsciousRange',
  'UniversalSpellCriticalDamage',
  'UniversalSpellLore',
  'UniversalSpellPower',
  'Unknown',
  'WeaponAlacrityClass',
  'WeaponAttackAbilityClass',
  'WeaponAttackBonusClass',
  'WeaponAttackBonusCriticalClass',
  'WeaponAttackBonusCriticalDamageType',
  'WeaponAttackBonusDamageType',
  'WeaponCriticalMultiplierClass',
  'WeaponCriticalRangeClass',
  'WeaponDamageAbilityClass',
  'WeaponDamageBonusClass',
  'WeaponDamageBonusCriticalClass',
  'WeaponDamageBonusCriticalDamageType',
  'WeaponDamageBonusCriticalStat',
  'WeaponDamageBonusDamageType',
  'WeaponDamageBonusStat',
  'WeaponKeenDamageType',
  'WeaponOtherDamageBonus',
  'WeaponOtherDamageBonusClass',
  'WeaponOtherDamageBonusCritical',
  'WeaponOtherDamageBonusCriticalClass',
  'WeaponProficiencyClass',
  'Weapon_Alacrity',
  'Weapon_Attack',
  'Weapon_AttackAbility',
  'Weapon_AttackAndDamage',
  'Weapon_AttackAndDamageCritical',
  'Weapon_AttackCritical',
  'Weapon_BaseDamage',
  'Weapon_CriticalMultiplier',
  'Weapon_CriticalMultiplier19To20',
  'Weapon_CriticalRange',
  'Weapon_Damage',
  'Weapon_DamageAbility',
  'Weapon_DamageCritical',
  'Weapon_Enchantment',
  'Weapon_EnchantmentClass',
  'Weapon_Keen',
  'Weapon_VorpalRange',
  'WildsurgeChance',
] as const;

export const KNOWN_EFFECT_TYPES = new Set<string>(EFFECT_TYPE_NAMES);
